const i18n_fields = {
  EN: [
    { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 5%' },
    { key: 'created_at', label: 'DateTime', sortable: false, thStyle: 'width: 14%' },
    { key: 'remote_addr', label: 'Attacker', sortable: false, thStyle: 'width: 10%' },
    { key: 'severity', label: 'Risk', sortable: false, thStyle: 'width: 10%' },
    { key: 'message', label: 'Message', sortable: false },
    { key: 'ruleid', label: 'RuleID', sortable: false },
    { key: 'is_block', label: 'Response', sortable: false, thStyle: 'width: 15%' },
  ],
  KO : [
    { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 5%' },
    { key: 'created_at', label: '일시', sortable: false, thStyle: 'width: 14%' },
    { key: 'remote_addr', label: '공격자', sortable: false, thStyle: 'width: 10%' },
    { key: 'severity', label: '위험도', sortable: false, thStyle: 'width: 10%' },
    { key: 'message', label: '설명', sortable: false },
    { key: 'ruleid', label: '정책 ID', sortable: false },
    { key: 'is_block', label: '대응', sortable: false, thStyle: 'width: 15%' },
  ],
  JP : [
    { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 5%' },
    { key: 'created_at', label: '日付/時間', sortable: false, thStyle: 'width: 14%' },
    { key: 'remote_addr', label: 'アタッカー', sortable: false, thStyle: 'width: 10%' },
    { key: 'severity', label: 'リスク', sortable: false, thStyle: 'width: 10%' },
    { key: 'message', label: 'メッセージ', sortable: false },
    { key: 'ruleid', label: 'ルールID', sortable: false },
    { key: 'is_block', label: '応答', sortable: false, thStyle: 'width: 15%' },
  ]
}

const domain_manage_fields = {
  EN: [
    { key : 'domain', label: 'Domain', thStyle: 'width: 65%' },
    // { key : 'status', label: 'Status' },
    // { key : 'mode', label: 'Mode' },
    // { key : 'level', label: 'Policy Security Level' },
    { key: 'button', label: 'Action' },
  ],
  KO: [
    { key : 'domain', label: 'Domain', thStyle: 'width: 65%' },
    // { key : 'status', label: 'Status' },
    // { key : 'mode', label: 'Mode' },
    // { key : 'level', label: 'Policy Security Level' },
    { key: 'button', label: 'Action' },
  ],
  JP: [
    { key : 'domain', label: 'Domain', thStyle: 'width: 65%' },
    // { key : 'status', label: 'Status' },
    // { key : 'mode', label: 'Mode' },
    // { key : 'level', label: 'Policy Security Level' },
    { key: 'button', label: 'Action' },
  ]
}

const _i18n_info = {
  add: {
    EN: `added`,
    KO: `추가되었어요.`,
    JP: `追加しました`
  },
  domain : {
    EN: `changed domain!`,
    KO: `changed domain!`,
    JP: `ドメイン変更しました`
  },
}

const _i18n_error = {
  value_error : {
    EN: `the policy is incorrect`,
    KO: `올바른 설정이 아닙니다`,
    JP: `このポリシーは正しくありません`
  },
  policy_failed : {
    EN: `load failed policy summary`,
    KO: `load failed policy summary`,
    JP: `ロードに失敗したポリシーの概要`
  },
  policy_failed_2 : {
    EN: `policy summary error`,
    KO: `policy summary error`,
    JP: `ポリシー概要エラー`
  },
  policy_version : {
    EN: `policy latest version error`,
    KO: `policy latest version error`,
    JP: `ポリシー最新バージョンエラー`
  },
  mmdb_version : {
    EN: `mmdb latest version error`,
    KO: `mmdb latest version error`,
    JP: `mmdb最新バージョンエラー`
  },
}

const _i18n_alert = {
  policy_check : {
    EN: `incorrect policy`,
    KO: `incorrect policy`,
    JP: `正しくないポリシー`
  },
  domain_check : {
    EN: `incorrect domain's policy`,
    KO: `incorrect domain's policy`,
    JP: `正しくないドメインのポリシー`
  },
  domain_check_2 : {
    EN: `no have domain`,
    KO: `no have domain`,
    JP: `ドメインがありません`
  },
  domain_check_3 : {
    EN: `no have domain when load`,
    KO: `no have domain when load`,
    JP: `ロード時にドメインがありません`
  },
  domain_check_4 : {
    EN: `incorrect domain`,
    KO: `incorrect domain`,
    JP: `正しくないドメイン`
  },
  domain_check_5 : {
    EN: `domain should be not contain blank`,
    KO: `domain should be not contain blank`,
    JP: `ドメインには空白を含めないでください`
  },
  domain_check_6 : {
    EN: `exist domain`,
    KO: `exist domain`,
    JP: `存在するドメインです`
  },
  URL_check : {
    EN: `incorrect redirection URL`,
    KO: `incorrect redirection URL`,
    JP: `正しくないリダイレクト URL`
  },
  save_policy: {
    EN: `failed saving policy to agent`,
    KO: `failed saving policy to agent`,
    JP: `ポリシーをエージェントに保存できませんでした`
  },
}

const _i18n_data = {
  i18n_fields,
  domain_manage_fields,
  _i18n_info,
  _i18n_error,
  _i18n_alert
}

export default _i18n_data